import { Box, Chip, Grid, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import erimg from "../Assets/Img/ER.svg";
import ProfileImg from "../Assets/Img/Imgs.png";
import filter from "../Assets/Img/filter btn collab-req.png";
import { default as Sort, default as SortDown } from "../Assets/Img/sort.png";
import "../Assets/css/brand.css";
import { Pagination } from "../Common/Components/Pagination";
import { SearchBar } from "../Common/Components/SearchBar";
import axiosMain from "../http/axiosMain";

function CollabReqTable({ brandId, campaign_id }) {
  const location = useLocation();

  const navigate = useNavigate();
  const { id: campaignId } = useParams();
  // const [searchQuery, setSearchQuery] = useState("");
  const [sortDirectionFollowers, setSortDirectionFollowers] = useState(null);
  const [sortDirectionER, setSortDirectionER] = useState(null); // 'asc' | 'desc' | null

  const [influencers, setInfluencers] = useState([]);
  const [requestStatuses, setRequestStatuses] = useState({});
  // const [myRequests, setMyRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const recordsPerPages = 20;
  // const [isFavoritesFiltered, setIsFavoritesFiltered] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  // const [visiblePages, setVisiblePages] = useState([1, 2, 3, 4, "..."]);
  const [totalCount, setTotalCount] = useState(1);
  const [allInfluencers, setAllInfluencers] = useState([]);

  // new theme
  const [searchQuery, setSearchQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  // const [openSearch, setOpenSearch] = useState(false);

  // const handleBlur = () => {
  //   if (searchQuery === "") setIsFocused(false);
  // };

  useEffect(() => {
    const fetchData = async () => {
      fetchInfluencers(searchQuery);
    };

    // Debounce to avoid making too many requests on every keystroke
    const timer = setTimeout(() => fetchData(), 500);

    // Cleanup on searchTerm change
    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    fetchInfluencers();
  }, [currentPage, recordsPerPages]);

  // ER
  const handleSortER = () => {
    let newDirection;
    let sortedData;

    if (sortDirectionER === "asc") {
      newDirection = "desc";
      sortedData = [...influencers].sort(
        (a, b) =>
          parseFloat(b.instagram_stats?.engagement || 0) -
          parseFloat(a.instagram_stats?.engagement || 0)
      );
    } else {
      newDirection = "asc";
      sortedData = [...influencers].sort(
        (a, b) =>
          parseFloat(a.instagram_stats?.engagement || 0) -
          parseFloat(b.instagram_stats?.engagement || 0)
      );
    }

    setSortDirectionER(newDirection);
    setInfluencers(sortedData);
  };

  const fetchMyCampaignRequests = async () => {
    try {
      const res = await axiosMain.get("/api/v1/my-campaign-requests", {
        params: { campaign_id: campaignId },
      });
      // setMyRequests(res.data.requests);
      return res.data;
    } catch (err) {
      console.error("Error fetching campaign requests:", err);
    }
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setCurrentPage(1); // reset to first page on new search
      fetchInfluencers(searchQuery);
    }
  };

  const fetchInfluencers = async (searchQuery = null) => {
    setLoading(true);
    try {
      console.log(currentPage);
      let url = "/api/influencer/influencers?";

      // Add search query to URL if it exists
      if (searchQuery && searchQuery.trim()) {
        url += `search=${searchQuery.trim()}&`;
      }

      // Calculate pagination parameters and append them to the URL
      const from = (currentPage - 1) * recordsPerPages;
      const limit = recordsPerPages;
      url += `from=${from}&limit=${limit}`;

      // Make the request to the API
      const response = await axiosMain.get(url);

      // Fetch the campaign requests
      const requestData = await fetchMyCampaignRequests();

      // Map through influencers and merge with request status
      const finalData = response.data.influencers?.map((item) => ({
        ...item,
        request_status:
          requestData.requests.filter(
            (itm) => itm.influencer_id === item.user_id
          )?.length > 0
            ? requestData.requests.find(
                (itm) => itm.influencer_id === item.user_id
              ).request_status
            : null,
      }));

      // Update the state with the fetched influencers
      setAllInfluencers(finalData);
      setTotalCount(response.data.totalCount); // Assuming the API returns a total count of influencers
      setInfluencers(finalData);
    } catch (error) {
      console.error("Error fetching influencers:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMyCampaignRequests();
  }, []);

  const handleSortFollowers = () => {
    let newDirection;
    let sortedData;

    if (sortDirectionFollowers === "asc") {
      newDirection = "desc";
      sortedData = [...influencers].sort(
        (a, b) => parseInt(b.followers) - parseInt(a.followers)
      );
    } else {
      newDirection = "asc";
      sortedData = [...influencers].sort(
        (a, b) => parseInt(a.followers) - parseInt(b.followers)
      );
    }

    setSortDirectionFollowers(newDirection);
    setInfluencers(sortedData);
  };

  const sendCollabRequest = async (influencerId) => {
    try {
      const response = await axiosMain.post("/api/v1/make-request", {
        campaign_id: campaignId,

        influencer_id: influencerId,
      });
      if (response.status === 201) {
        // fetchInfluencers();
        setInfluencers(fetchInfluencers());
        // const newinfluencers = influencers.map();
        // setInfluencers([ ...influencers,
        //  { request_status:
        //     requestData.requests.filter(
        //       (itm) => itm.influencer_id == item.user_id
        //     ).length > 0
        //       ? requestData.requests.filter(
        //           (itm) => itm.influencer_id == item.user_id
        //         )[0].request_status
        //       : null,}])
      }

      toast.success("Request sent successfully!");

      setRequestStatuses((prev) => ({
        ...prev,
        [String(influencerId)]: "Pending",
      }));
    } catch (error) {
      toast.error("Error sending request");
      console.error("Error sending request", error);
      fetchMyCampaignRequests();
    }
  };

  // categoriesData.js
  const categories = [
    {
      category: "Food Influencers",
      id: "food",
    },
    {
      category: "Health and Wellness Influencers",
      id: "health",
    },
    {
      category: "Fashion Influencers",
      id: "fashion",
    },
    {
      category: "Lifestyle Influencers",
      id: "lifestyle",
    },
    {
      category: "Memes and Pop-culture Coverage Influencers",
      id: "memes",
    },
    {
      category: "Travel Influencers",
      id: "travel",
    },
    {
      category: "Family Influencers",
      id: "family",
    },
    {
      category: "Gaming Influencers",
      id: "gaming",
    },
    {
      category: "Animal Influencers",
      id: "animal",
    },
    {
      category: "Beauty Influencers",
      id: "beauty",
    },
  ];

  const [open, setOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const toggleCategory = (id) => {
    setSelectedCategories((prev) =>
      prev.includes(id) ? prev.filter((cat) => cat !== id) : [...prev, id]
    );
  };

  const handleClearAll = () => {
    setSelectedCategories([]);
  };

  const handleApply = () => {
    console.log("Selected:", selectedCategories);
    setOpen(false); // Close sidebar on apply
  };
  return (
    <>
      {/* <div className="d-flex align-items-center mb-3">
        <button
          className="collab-back no-hover me-2"
          onClick={() => navigate(-1)}
          style={{ fontSize: "20px", border: "none", background: "none" }}
        >
          &lt; Back
        </button>
      </div> */}
      {open && (
        <div className="filter-overlay">
          <div className="filter-sidebar">
            <div className="filter-header d-flex justify-content-between align-items-center">
              <h5>Filters</h5>
              <button
                onClick={() => setOpen(false)}
                className="btn-close"
              ></button>
            </div>

            <div className="FilterBox">
              <div className="filter-tabs">
                <div className="tab active">By Category/ies</div>
                <div className="tab">By Engagement Rate</div>
                <div className="tab">By Followers</div>
                <div className="tab">By Audience Gender</div>
              </div>

              <div className="category-list">
                {categories.map((cat) => (
                  <div key={cat.id} className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={cat.id}
                      checked={selectedCategories.includes(cat.id)}
                      onChange={() => toggleCategory(cat.id)}
                    />
                    <label className="form-check-label" htmlFor={cat.id}>
                      {cat.category}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="filter-footer d-flex justify-content-between mt-3">
              <button
                className="btn btn-link text-muted"
                onClick={handleClearAll}
              >
                Clear All
              </button>
              <button className="btn btn-success" onClick={handleApply}>
                Apply
              </button>
            </div>
          </div>
        </div>
      )}

      <nav aria-label="breadcrumb" style={{ marginBottom: "10px" }}>
        <ol className="breadcrumb custom-breadcrumb m-0 p-0 d-flex align-items-center">
          <li
            className={`breadcrumb-item ${
              location.pathname.startsWith("/campaign-details") ? "fw-bold" : ""
            }`}
          >
            <span
              onClick={() => navigate(-1)}
              style={{
                cursor: "pointer",
                display: "inline-block",
                lineHeight: "1.5",
              }}
            >
              Campaign
            </span>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Collaboration
          </li>
        </ol>
      </nav>

      <div className="container collab-request mt-4 p-4">
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          className="mb-4"
        >
          {/* Left - Heading */}
          <Grid item>
            <h1 className="find-text mb-0">
              Find and Connect with Influencers
            </h1>
          </Grid>

          {/* Right - Search + Filter */}
          <Grid item xs={12} md={6}>
            <div className="d-flex justify-content-end align-items-center">
              {/* Search form */}
              <SearchBar
                searchQuery={searchQuery}
                setSearchQuery={(value) => {
                  setCurrentPage(1);
                  setSearchQuery(value);
                }}
              />

              {/* Filter icon */}
              <div className="filter-icon-container">
                <img
                  src={filter} // Replace with your actual filter image path
                  alt="Filter"
                  className="filter-icon"
                  onClick={() => setOpen(true)}
                />
              </div>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className="table-responsive collab-req">
              <table className="table collab-req-table">
                <thead className="text-center">
                  <tr>
                    <th>Creators</th>
                    <th>Category</th>
                    <th
                      className="d-flex align-items-center gap-1"
                      onClick={handleSortER}
                      style={{ cursor: "pointer" }}
                    >
                      ER
                      <img
                        src={erimg}
                        alt="Info Icon"
                        width="16"
                        height="16"
                        data-bs-toggle="tooltip"
                        title="Engagement Rate"
                      />
                      <img
                        src={
                          sortDirectionER === "asc"
                            ? SortDown
                            : sortDirectionER === "desc"
                            ? SortDown
                            : Sort
                            ? SortDown
                            : Sort
                        }
                        className="img-fluid Sort"
                        alt="Sort Icon"
                        width="16"
                        height="16"
                      />
                    </th>

                    <th
                      onClick={handleSortFollowers}
                      style={{ cursor: "pointer" }}
                    >
                      Followers{" "}
                      <img
                        src={
                          sortDirectionFollowers === "asc"
                            ? SortDown
                            : sortDirectionFollowers === "desc"
                            ? SortDown
                            : Sort
                            ? SortDown
                            : Sort
                        }
                        className="img-fluid Sort"
                        alt="Sort Icon"
                      />
                    </th>
                    {/* <th>Social Presence</th> */}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody className="align-middle text-center">
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center py-5">
                        Loading...
                      </td>
                    </tr>
                  ) : influencers?.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center py-5">
                        No influencers found.
                      </td>
                    </tr>
                  ) : (
                    influencers?.map((influencer) => (
                      <tr key={influencer.id} className="py-3">
                        <td className="py-3 px-3">
                          <div className="d-flex align-items-center gap-2">
                            <img
                              src={
                                influencer?.profile ||
                                influencer?.ProfileImg ||
                                ProfileImg
                              }
                              className="img-fluid"
                              alt={influencer?.handle_name || "Influencer"}
                              style={{
                                width: "70px",
                                height: "70px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                border: "2px solid #ccc",
                              }}
                            />
                            <span>
                              {influencer.first_name ||
                              influencer.last_name ||
                              influencer.middle_name
                                ? `${influencer.first_name || ""} ${
                                    influencer.middle_name || ""
                                  } ${influencer.last_name || ""}`.trim()
                                : influencer.handle_name}
                            </span>
                          </div>
                        </td>
                        <td className="py-3 px-3">
                          <div className="InfluencerGenre">
                            {influencer?.category?.length ? (
                              (() => {
                                const categories = influencer.category
                                  ?.map((cat) => cat.name)
                                  .filter(Boolean);
                                return (
                                  <Box display={"flex"} gap={1}>
                                    {categories[0]}
                                    {categories?.length > 1 && (
                                      <Tooltip
                                        title={categories.slice(1).join(", ")}
                                        placement="bottom"
                                      >
                                        <Chip
                                          sx={{
                                            backgroundColor: "#ccc",
                                            color: "#333",
                                            fontFamily: "Poppins, sans-serif",
                                            cursor: "pointer",
                                          }}
                                          label={`+ ${categories?.length - 1}`}
                                        />
                                      </Tooltip>
                                    )}
                                  </Box>
                                );
                              })()
                            ) : (
                              <>N/A</>
                            )}
                          </div>
                        </td>
                        <td className="py-3 px-3">
                          {influencer.instagram_stats.engagement}
                        </td>

                        <td className="py-3 px-3">{influencer.followers}</td>
                        {/* <td className="py-3 px-3">{influencer.engagement}</td> */}
                        <td className="py-3 px-3">
                          <button
                            className="btn view-detail-collab-req btn-sm me-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(`/influencer/${influencer.user_id}`);
                            }}
                          >
                            View Details
                          </button>
                          <button
                            className={`btn btn-outline-success btn-xl send-request ${
                              influencer.request_status === "Accepted"
                                ? "btn-success"
                                : influencer.request_status === "Rejected"
                                ? "btn-danger"
                                : influencer.request_status === "Pending"
                                ? "btn-warning"
                                : ""
                                ? "btn-danger"
                                : influencer.request_status === "Pending"
                                ? "btn-warning"
                                : ""
                            }`}
                            onClick={() =>
                              sendCollabRequest(influencer?.user_id)
                            }
                            disabled={[
                              "Pending",
                              "Accepted",
                              "Rejected",
                              "Sent",
                            ].includes(influencer?.request_status)}
                          >
                            {(() => {
                              switch (influencer?.request_status) {
                                case "Pending":
                                  return "Pending";
                                case "Accepted":
                                  return "Accepted";
                                case "Rejected":
                                  return "Rejected";
                                case "Sent":
                                  return "Sent";
                                default:
                                  return "Send Request";
                              }
                            })()}
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </Grid>
        </Grid>

        {/* ✅ Pagination Block */}
        <Pagination
          currentPage={currentPage}
          recordsPerPages={recordsPerPages}
          totalCount={totalCount}
          onPageChange={(page) => {
            setCurrentPage(page);
          }}
        />
      </div>
    </>
  );
}

export default CollabReqTable;
